module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option-list weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.oList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "option-item weex-ct weex-div",
      class: [item.checked && 'option-item-current'],
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.checkChange(item)
        }
      }
    }, [_c('p', {
      staticClass: "text weex-el weex-text",
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1acbb35a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1acbb35a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-date-cycle-picker/option-list-circle.vue
// module id = 580
// module chunks = 0 1